import React, { useEffect, useState } from 'react';
import '../../Admin1/Pages/admin1.css';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import axios from 'axios';
import Loader from '../../../safreeimg/loader.gif';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const OrgAlarmManagement = () => {
    const [organisations, setOrganisations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [showForm, setShowForm] = useState(false);
    const [selectedOrganisation, setSelectedOrganisation] = useState(null);

    const rowsPerPage = 10;

    const fetchOrganisations = async () => {
        try {
            setLoading(true);
            setError(null);

            const token = localStorage.getItem('token');
            if (!token) {
                setError('No token found');
                setLoading(false);
                return;
            }

            const response = await axios.get('https://api.safree.org/api-v2022/organization/auth/v1/getOrgAlarms', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            setOrganisations(response.data.data.alarms);
        } catch (err) {
            setError('Error fetching data: ' + err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOrganisations();
    }, []);

    const totalPages = Math.ceil(organisations.length / rowsPerPage);
    const currentRows = organisations.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePageChange = (direction) => {
        if (direction === 'prev' && currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
        if (direction === 'next' && currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const getPageNumbers = () => {
        const maxPageNumbersToShow = 5;
        const startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
        const endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

        const pageNumbers = [];
        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }
        return pageNumbers;
    };

    const handleView = (organisation) => {
        setSelectedOrganisation(organisation);
        setShowForm(true);
    };

    const closeForm = () => {
        setShowForm(false);
    };

    if (loading) return <div className='loading'><img src={Loader} alt="Loading..." /></div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div className="container user-management">
            {/* Header Section */}
            <div className="row header">
                <div className="col-md-6">
                    <p className="sub-heading">Alarm Management</p>
                </div>
            </div>

            <div className="content-wrapper">
                {/* Table Section */}
                <div className="table-container" style={{ minWidth: "100%", overflowX: "auto" }}>
                    <table className="styled-table">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Date</th>
                                <th style={{ minWidth: "324px" }}>Reason</th>
                                <th>Audios</th>
                                <th>Location</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentRows.map((alarm, index) => (
                                <tr key={alarm.alarmId}>
                                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                                    <td>{alarm.userName}</td>
                                    <td>{alarm.email}</td>
                                    <td>{alarm.phoneNumber}</td>
                                    <td>{new Date(alarm.created).toLocaleDateString()}</td>
                                    <td>{alarm.reasonTitle}</td>
                                    <td>
                                        {alarm.chunkFiles && alarm.chunkFiles.length > 0 ? (
                                            <>
                                                <audio controls>
                                                    <source src={alarm.chunkFiles[0]} type="audio/aac" />
                                                    Your browser does not support the audio element.
                                                </audio>
                                                <br />
                                            </>
                                        ) : (
                                            "No Audio Available"
                                        )}
                                    </td>
                                    <td>
                                        <button
                                            className="btn btn-view"
                                            onClick={() => handleView(alarm)}
                                        >
                                            View
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {/* Pagination Section */}
                    <div className="pagination-container">
                        <button
                            className="pagination-btn"
                            onClick={() => handlePageChange('prev')}
                            disabled={currentPage === 1}
                        >
                            &laquo; Prev
                        </button>
                        {getPageNumbers().map((page) => (
                            <button
                                key={page}
                                className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
                                onClick={() => setCurrentPage(page)}
                            >
                                {page}
                            </button>
                        ))}
                        <button
                            className="pagination-btn"
                            onClick={() => handlePageChange('next')}
                            disabled={currentPage === totalPages}
                        >
                            Next &raquo;
                        </button>
                    </div>
                </div>
            </div>

            {/* Side Form */}
            <div className={`side-form ${showForm ? 'show' : ''}`}>
                <h3>Location</h3>
                {selectedOrganisation && (
                    <div>

                        {/* Map Section */}
                        {selectedOrganisation.location && selectedOrganisation.location.latitude && selectedOrganisation.location.longitude && (
                            <MapContainer
                                center={[selectedOrganisation.location.latitude, selectedOrganisation.location.longitude]}
                                zoom={13}
                                style={{ height: '300px', width: '100%' }}
                            >
                                <TileLayer
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                />
                                <Marker
                                    position={[selectedOrganisation.location.latitude, selectedOrganisation.location.longitude]}
                                    icon={new L.Icon({ iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png', iconSize: [25, 41], iconAnchor: [12, 41] })}
                                >
                                    <Popup>
                                        <strong>Location:</strong> {selectedOrganisation.location.raw}
                                    </Popup>
                                </Marker>
                            </MapContainer>
                        )}
                        <p><strong>Location:</strong> {selectedOrganisation.address}</p>
                        <p><strong>Latitude:</strong> {selectedOrganisation.location.latitude}</p>
                        <p><strong>Longitude:</strong> {selectedOrganisation.location.longitude}</p>

                    </div>
                )}
                <button className="btn-cancel" onClick={closeForm}>Close</button>
            </div>
        </div>
    );
};

export default OrgAlarmManagement;
